const initialState = {
  lastStep: localStorage.getItem("lastStep"),
};

export const stepsReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case "SET_LAST_STEP":
      localStorage.setItem("lastStep", action.payload);
      return {
        ...state,
        lastStep: action.payload,
      };
    default:
      return state;
  }
};
